import { useMutation, useQueryClient } from 'react-query';
import { getSubscriptionBlockUseCases } from '@subscriptions/composition';

/**
 * Hook for deleting a subscription block.
 *
 * @returns Mutation result for deleting a subscription block
 */
export const useDeleteSubscriptionBlock = () => {
  const queryClient = useQueryClient();
  const { deleteSubscriptionBlock } = getSubscriptionBlockUseCases();

  return useMutation<void, Error, string>((blockUuid) => deleteSubscriptionBlock.execute(blockUuid), {
    onSuccess: () => {
      queryClient.invalidateQueries(['subscriptions', 'blocks', 'list']);
    },
  });
};
